import React, { useRef, useState } from "react";
import sellerImg from '../../components/icons/sellerImage.jpg'
import Logo from '../../components/logo/Logo.js';
import RegistrationStepperForm from './RegistrationStpperForm.js';
import { Helmet } from "react-helmet-async";
import WebsiteNavbar from "../Website/Navbar";
import Footer from "../Website/footer";
import { useParams } from 'react-router-dom';
import { useEffect } from "react";
import { postData } from "src/webService/webService";
import { ToastContainer } from "react-toastify";

export default function SellerRegisterForm () {
    const { token } = useParams();
    const [isActive, setIsActive] = useState(false);
    const [isFormVisible, setIsFormVisible] = useState(false);
    const onboardFormSectionRef = useRef(null);

    useEffect(() => {
      postData("auth/seller/validate/invite/"+token, [], null).then((res) => {
          if(res.activeStatus == true) {
                setIsActive(true);
            } else {
                setIsActive(false);
            }
      });
    }, [])

    return(
        <div>
            <ToastContainer position="top-right" />
            <Helmet>
                <title>{isActive ? "Empowering your Business Future." : "Link expired" }</title>
            </Helmet>
            <WebsiteNavbar loginButton={'hide'} />

            <section>
                <div className="sellerRegisterBgrd">
                    <div className="container">
                        <div className="row registerbanner">
                            <div className="col-7 d-flex align-items-center">
                                <div className="text-left">
                                    <h2>{isActive ? "Complete Your Seller Profile" : "Link Expired"}</h2>
                                    <p>{isActive ? "You’re almost there! Use this guide to complete your seller profile and set your account password. This helps us activate your account and get you ready to start selling on Amazon." : "Please contact support for any assistance"}</p>
                                    {isActive && <button onClick={() => {
                                        setIsFormVisible(true);
                                        setTimeout(() => {
                                            onboardFormSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
                                        }, 100);
                                    }}>Continue to setup</button>}
                                </div>
                            </div>
                            <div className="col-5 d-flex align-items-center p-3">
                                <img src={sellerImg} width='100%' />
                            </div>
                        </div>
                        
                        {isFormVisible && <div className={"d-flex justify-content-center py-5"} ref={onboardFormSectionRef}><RegistrationStepperForm /></div>}
                    </div>
                </div>
            </section>

            <Footer />

        </div>
    )
}